import React, { useEffect } from 'react';
import { resolve } from '@cvent/nucleus-dynamic-css';
import { injectTestId, resolveTestId } from '@cvent/nucleus-test-automation';
import Speaker from './Speaker';
import { Column, Row } from 'nucleus-core/layout/grid';
import { filter } from 'lodash';
import { useLazyList } from '@cvent/lazy-rendering-list';

export default function SpeakersList({ showBioModal, displayOptions, translate, viewBioModal, categoryGrouping,
  speakerCategories, speakers, keywordFilterValue, ...rest }) {
  const [maxSpeakersToDisplay, Sentinel, resetMaxSessionsToDisplay] = useLazyList(speakers.length);

  useEffect(resetMaxSessionsToDisplay, [keywordFilterValue, speakers.length]);

  let speakerIndex = 0;

  function generateSpeaker(speaker) {
    const index = speakerIndex++;
    if (index === maxSpeakersToDisplay) {
      return <Sentinel key="sentinel" />;
    }
    if (index > maxSpeakersToDisplay) {
      return null;
    }
    return (
      <div key={speaker.id} {...resolve(rest, 'speakerContainer')}>
        <div {...resolve(rest, 'speakerCard')} {...resolveTestId(rest, '-speakerCard')}>
          <Speaker
            speaker={speaker}
            classes={rest.classes}
            style={rest.style}
            translate={translate}
            displayOptions={displayOptions}
            displayViewBioButton={viewBioModal.displayModal}
            viewBioButtonText={viewBioModal.modalButtonText}
            showBioModal={showBioModal}
          />
        </div>
      </div>
    );
  }

  function generateSpeakers(speakersSublist) {
    return (
      <div {...resolve(rest, 'speakersContainer')} {...resolveTestId(rest, '-speakersContainer')}>
        {speakersSublist.map(generateSpeaker)}
      </div>
    );
  }

  if (categoryGrouping) {
    return speakerCategories.map((category) => {
      const categorySpeakers = filter(speakers, speaker => speaker.categoryId === category.id);
      return (categorySpeakers && categorySpeakers.length > 0) ? (
        <div key={`speakerCategoryContainer-${category.id}`} {...injectTestId(`speakerCategory-${category.id}`)}>
          <Row key={`speakerCategoryHeaderRow-${category.id}`}>
            <Column>
              <div
                key={`speakerCategoryGrouping-${category.id}`} {...resolve(rest, 'categoryGrouping')}
                {...injectTestId(`speakerCategoryGrouping-${category.id}`)}
              >
                { translate(category.name) }
              </div>
            </Column>
          </Row>
          <Row key={`speakerCategorySpeakersRow-${category.id}`}>
            <Column>
              {generateSpeakers(categorySpeakers)}
            </Column>
          </Row>
        </div>
      ) : null;
    });
  }
  return generateSpeakers(speakers);
}
